import { isUserLoggedIn, getRules } from '@/utils/auth'
import { useUserStore } from '@/stores/user'
import type { RolesType, Rule, Actions, Subjects } from '@/plugins/casl/ability'
import { useAbility } from '@/composables/useAbility'

export default defineNuxtRouteMiddleware(async (to) => {
  const isLoggedIn = isUserLoggedIn()

  if (to.meta.unauthenticatedOnly && !isLoggedIn) {
    return
  }

  if (to.meta.unauthenticatedOnly && isLoggedIn) {
    return navigateTo('/')
  }

  if (!to.meta.unauthenticatedOnly && !isLoggedIn) {
    return navigateTo('/login')
  }

  const userStore = useUserStore()
  const userData = await userStore.getUserData()

  if (userData && 'roles' in userData) {
    const ability = useAbility()
    const rules = getRules(userData.roles.map(role => role.toLowerCase()) as RolesType[])
    ability.update(rules)
    useCookie<Rule[]>('userAbilityRules').value = rules
    const canNavigate = to.meta.action && to.meta.subject
      ? ability.can(to.meta.action as Actions, to.meta.subject as Subjects)
      : false

    return !canNavigate && to.name !== 'not-permission' ? navigateTo('/not-permission') : undefined
  } else {
    useCookie(storageTokenKeyName).value = null
    useCookie(storageRefreshTokenKeyName).value = null
  }

  return navigateTo('/login')
})
